import { Category } from "../models/basic/category";
import { AbstractService, Filters } from "./abstract-service";
import { URLS } from "./app-urls";

export type CategoryFilter = Filters & {
    search: string;
    active: string;
};

export class CategoryService extends AbstractService<Category> {

    constructor() {
        super(URLS.CATEGORY);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if(processedFilter.active) {
            if(processedFilter.active === "0") {
                delete processedFilter.active;
            } else {
                processedFilter.active = processedFilter.active === "active";
            }
        }

        return processedFilter;
    }

}
